"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Application = void 0;
var vue_1 = __importDefault(require("vue"));
var composition_api_1 = __importDefault(require("@vue/composition-api"));
var Calculator_vue_1 = __importDefault(require("./components/Calculator.vue"));
vue_1["default"].config.productionTip = false;
vue_1["default"].use(composition_api_1["default"]);
var Application = /** @class */ (function () {
    function Application() {
    }
    Application.prototype.run = function () {
        this.initCalculator();
    };
    Application.prototype.initCalculator = function () {
        new vue_1["default"]({
            render: function (h) { return h(Calculator_vue_1["default"]); },
        }).$mount('#app-calculator');
    };
    return Application;
}());
exports.Application = Application;
